<div
  *transloco="let t; read: 'documents.view'"
  class="xi-modal__container document-view__container"
>
  <div class="document-view__title">
    <h2>{{ t('document-details') }}</h2>

    @if (!options.hideOpenNewTabAction) {
      <xi-icon-button
        icon="new_window"
        buttonSize="large"
        (onClick)="onOpenNewTab()"
        [tooltip]="{ text: t('open-new-window') }"
      ></xi-icon-button>
    }
  </div>

  <app-document-view
    [options]="options()"
    (close)="modalClosed.emit($event || hasChanged)"
    [(hasChanged)]="hasChanged"
    (documentIdChange)="onDocumentIdChange($event)"
    (pageChange)="onPageChange($event)"
    (highlightChange)="onHighlightChange($event)"
  ></app-document-view>
</div>
